import React from "react";
import { Button, PasswordInput } from "@mantine/core";
import { PasswordFormType } from "@/pages/User/Profile/Profile";

interface PersonalDataProps {
  formData: PasswordFormType;
  setNewPassword: (values: {
    currentPassword: string;
    newPassword: string;
    repeatPassword: string;
  }) => void;
}

const PersonalData: React.FC<PersonalDataProps> = ({
  formData,
  setNewPassword,
}) => {
  return (
    <form
      className="password-form"
      onSubmit={formData.onSubmit(setNewPassword)}
    >
      <div className="text-[#004a99] text-base font-bold">
        {window.innerWidth > 665 ? "Promjena lozinke" : "Promjeni lozinku"}
      </div>
      <div className="password-inputs">
        <PasswordInput
          className="flex-1"
          label="Stara lozinka"
          placeholder="*********"
          key={formData.key("currentPassword")}
          {...formData.getInputProps("currentPassword")}
        />
        <PasswordInput
          className="flex-1"
          label="Nova lozinka"
          placeholder="*********"
          key={formData.key("newPassword")}
          {...formData.getInputProps("newPassword")}
        />
        <PasswordInput
          className="flex-1"
          label="Ponovi novu lozinku"
          placeholder="*********"
          key={formData.key("repeatPassword")}
          {...formData.getInputProps("repeatPassword")}
        />
      </div>
      <div className="password-button-container">
        <Button
          type="submit"
          variant="filled"
          color="#004a99"
          radius="xl"
          size="md"
          className="password-save-button"
        >
          Spremi
        </Button>
      </div>
    </form>
  );
};

export default PersonalData;
